import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Skeleton,
} from "@mui/material";
import axios from "axios";
import {
  FormLabel,
  ModalError,
  ModalSuccess,
  PrimaryButton,
  SecondaryButton,
  TextInput,
} from "components";
import { useEffect, useState } from "react";
import { hardBaseUrl } from "services/urlConstant";
import { getErrors } from "utils";

const ModalFormParameterClientClassification = ({
  open,
  onClose,
  preload,
  getDataTable,
}) => {
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const [loadingPage, setLoadingPage] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);
  const [payload, setPayload] = useState({
    classification_name: "",
    description: "",
  });

  const handleChangePayload = (value, key) => {
    setPayload(currentState => ({
      ...currentState,
      [key]: value,
    }));
  };

  const getDetail = async () => {
    setLoadingPage(true);
    try {
      const res = await axios.get(
        `${hardBaseUrl}/publisher/classification/${preload}`,
        { headers }
      );
      const data = res?.data?.data;
      setPayload({
        classification_name: data.classification_name,
        description: data.description,
      });
    } catch (error) {
      ModalError(error?.response ? getErrors(error?.response) : error);
    } finally {
      setLoadingPage(false);
    }
  };
  const handleSubmit = async () => {
    const method = preload ? axios.put : axios.post;
    try {
      setLoadingButton(true);
      await method(
        `${hardBaseUrl}/publisher/classification${
          preload ? `/${preload}` : "/create"
        }`,
        payload,
        { headers }
      );
      ModalSuccess(
        `Successfully ${preload ? "update" : "save"} client classification`
      ).then(() => getDataTable());
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingButton(false);
      onClose();
    }
  };

  useEffect(() => {
    if (preload) {
      getDetail();
    }
  }, [preload]);

  return (
    <Dialog fullWidth open={open} onClose={onClose}>
      <DialogTitle>{`${
        preload ? "Edit" : "Add"
      } Client Classification`}</DialogTitle>
      <DialogContent dividers>
        {loadingPage ? (
          <Grid container direction="column" rowSpacing={2}>
            {Object.keys(payload)?.map((_, index) => (
              <Grid item key={index}>
                <Box mb="8px">
                  <Skeleton variant="rounded" width="40%" height={25} />
                </Box>
                <Skeleton variant="rounded" width="100%" height={30} />
              </Grid>
            ))}
          </Grid>
        ) : (
          <Grid container direction="column" rowSpacing={1}>
            {MockFieldForm?.map(({ title, key, multiline }, index) => (
              <Grid item key={index}>
                <FormLabel label={title} required={!multiline} />
                <TextInput
                  placeholder={title}
                  value={payload?.[key]}
                  onChange={e => handleChangePayload(e?.target?.value, key)}
                  disabled={loadingButton}
                  multiline={multiline}
                  rows={multiline ? 4 : 1}
                />
              </Grid>
            ))}
          </Grid>
        )}
      </DialogContent>
      <DialogActions>
        <SecondaryButton
          label="Cancel"
          disabled={loadingPage}
          onClick={onClose}
        />
        <PrimaryButton
          label={loadingButton ? "Saving" : "Save"}
          loading={loadingButton}
          disabled={loadingPage || loadingButton}
          onClick={handleSubmit}
        />
      </DialogActions>
    </Dialog>
  );
};

const MockFieldForm = [
  {
    title: "Name",
    key: "classification_name",
  },
  {
    title: "Description",
    key: "description",
    multiline: true,
  },
];
export default ModalFormParameterClientClassification;
